import React, { useEffect, useRef } from "react";
import ContactSection from "../components/contactForm";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Lottie from "react-lottie-player";
import animationData from "./Contact-Banner-Animtion.json";

const ContactPage = ({ role }) => {  // Add role prop here
  const lottieRef = useRef(null);

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(1); // Optional: Control animation speed
    }
  }, []);

  return (
    <div>
 
      {/* Full Width Map */}
      {/* <div
        data-aos="zoom-in"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "100px",
          marginBottom: "100px",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h3
          style={{
            fontSize: "40px",
            fontWeight: "bold",
            marginBottom: "10px",
          }}
        >
          Site Map
        </h3>
        <div className="w-full px-4 md:px-0" style={{ maxWidth: "1000px" }}>
          <div className="relative w-full pt-[56.25%] rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3147.8813626684994!2d-122.06592588447884!3d37.90025177973436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808561a1fa6f8723%3A0xf5a683b17088e0eb!2s1646%20N%20California%20Blvd%2C%20Walnut%20Creek%2C%20CA%2094596!5e0!3m2!1sen!2sus!4v1710778862121!5m2!1sen!2sus"
              className="absolute top-0 left-0 w-full h-full border-0 rounded-lg"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div> */}

      {/* Contact Form and Property Card - Pass role prop to enable editing */}
<div style={{marginTop:'120px'}}>
      <ContactSection role={role} />
      </div>
    </div>
  );
};

export default ContactPage;